import React from 'react'
import { Area, AreaChart, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';

export default function SparkLineChart() {
    const data = [
      {
        name: "1 - 10 Aug",
        uv: 55,
      },
      {
        name: "11 - 20 Aug",
        uv: 30,
      },
      {
        name: "21 - 30 Aug",
        uv: 60,
      },
      {
        name: "1 - 10 Nov",
        uv: 40,
      },
      {
        name: "11 - 20 Nov",
        uv: 90,
      },
    ];

  return (
    <div>
      <AreaChart
        width={900}
        height={400}
        data={data}
        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#fff" stopOpacity={0.8} />
            <stop offset="100%" stopColor="#fff" stopOpacity={0.1} />
          </linearGradient>
        </defs>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Area
          type="monotone"
          dataKey="uv"
          stroke="#FFF"
          fillOpacity={1}
          fill="url(#colorUv)"
        />
      </AreaChart>
    </div>
  );
}
